import { CSSProperties, ReactNode } from "react";
import { Link } from "react-router-dom";
import { useScrollToTop } from "../../hooks/useScrollToTop";

interface IReactRouterLinkProps {
  to: string;
  linkElement: string | ReactNode;
  style?: CSSProperties;
  target?: React.HTMLAttributeAnchorTarget;
  rel?: string;
  itemProp?: string;
  isLinkUnderline?: boolean;
  isDisabled?: boolean;
}

const ReactRouterLink: React.FC<IReactRouterLinkProps> = ({
  to,
  linkElement,
  style = { color: "rgba(0, 0, 0, 0.6)" },
  target,
  rel,
  itemProp,
  isLinkUnderline = true,
  isDisabled,
}: IReactRouterLinkProps) => {
  return isDisabled ? (
    <>{linkElement}</>
  ) : (
    <Link
      to={to}
      style={{
        ...style,
        textDecoration: isLinkUnderline ? "underline" : "none",
      }}
      target={target}
      rel={rel}
      itemProp={itemProp}
    >
      {linkElement}
    </Link>
  );
};

export default ReactRouterLink;
